import * as React from 'react'

import { XIcon } from 'lucide-react'
import { observer } from 'mobx-react'

import TwoMonthsDatePickerStore from '~/client/src/desktop/components/TwoMonthsDatePicker/TwoMonthsDatePicker.store'
import { Button } from '~/client/src/shared/components/shadcn-ui/button'
import Localization from '~/client/src/shared/localization/LocalizationManager'

import DatePickerMonths from './DatePickerMonths'

import './TwoMonthsDatePicker.scss'

// localization: translated

interface IProps<StoreType> {
  store: StoreType

  className?: string
  customHeaderRenderer?: () => JSX.Element
  customFooterRenderer?: () => JSX.Element
}

@observer
export default class TwoMonthsDatePicker<
  StoreType extends TwoMonthsDatePickerStore,
> extends React.Component<IProps<StoreType>> {
  public render() {
    const { store, className, children } = this.props
    const { isShown, displayedMonths, titleTranslatorKey, shouldHideCalendar } =
      store
    if (!isShown) {
      return null
    }

    return (
      <div className={`${className} tm-dp-container col x-stretch y-start`}>
        {titleTranslatorKey && this.renderHeader()}
        {children}
        {!shouldHideCalendar && (
          <div className="tm-dp-months-container row y-start x-between no-flex-children-direct">
            {displayedMonths.map((value, index) => {
              return (
                <div className="tm-dp-month-picker" key={index}>
                  <DatePickerMonths
                    store={store}
                    isFirstMonth={!index}
                    date={value}
                  />
                </div>
              )
            })}
          </div>
        )}
        {this.renderFooter()}
      </div>
    )
  }

  protected renderHeader() {
    if (this.props.customHeaderRenderer) {
      return this.props.customHeaderRenderer()
    }

    const { titleTranslatorKey, hide } = this.props.store
    return (
      <div className="row pb10 mb20 bb-light-grey y-center">
        <div className="text bold uppercase extra-large">
          {titleTranslatorKey && Localization.getText(titleTranslatorKey)}
        </div>
        <Button
          variant="ghost"
          size="icon-sm"
          className="tw:flex-none!"
          aria-label={Localization.translator.close}
          onClick={hide}
        >
          <XIcon />
        </Button>
      </div>
    )
  }

  protected renderFooter() {
    if (this.props.customFooterRenderer) {
      return this.props.customFooterRenderer()
    }

    const { onApplyClick, hide } = this.props.store

    return (
      <div className="tm-dp-btn-container">
        <Button variant="ghost" onClick={hide}>
          {Localization.translator.cancel}
        </Button>
        <Button variant="default" onClick={onApplyClick}>
          {Localization.translator.apply}
        </Button>
      </div>
    )
  }
}
